import { render, staticRenderFns } from "./CSeparator.vue?vue&type=template&id=084cf66f&"
import script from "./CSeparator.vue?vue&type=script&lang=js&"
export * from "./CSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports